module.exports = __webpack_public_path__ + "static/media/ornaments-small.69abdf3f.gif";